export const medicijnOpReisHulpNamespace = "medicijn-op-reis-hulp";

export const medicijnOpReisHulpUrlPath = "regelingen/medicijnen-mee-op-reis/advies-verklaringen";
